'use client';

import { c as _c } from "react/compiler-runtime";
import { memo } from 'react';
import { VaultYourPositionChartLoading } from '../VaultYourPositionChart';
import { VaultYourTransactionsLoading } from '../VaultYourTransactions';
const VaultYourPositionLoading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="gap-xl flex flex-col"><VaultYourPositionChartLoading /><VaultYourTransactionsLoading /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default memo(VaultYourPositionLoading);